import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { StorageService } from '../services/storage.service';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private storageService: StorageService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authData = this.storageService.getAuthData();
    if (authData && authData.token) {
      const clonedRequest = request.clone({
        headers: request.headers.set('Authorization', 'Bearer ' + authData.token)
      });
      return next.handle(clonedRequest);
    }
    return next.handle(request);
  }
}